import React, { CSSProperties, FC } from 'react';
import cls from 'classnames';

import { BannerProps } from './Banner.types';
import { CaretRightIcon } from '@stashinvest/react-assets';

const Banner: FC<BannerProps> = (props) => {
	const { variant, className, onClick, maxLines } = props;

	const isDefaultVariant = variant.type === 'default';
	const maxLineStyle = (maxLines ? { '--numMaxLines': maxLines } : {}) as CSSProperties;

	const Inner = (
		<>
			<div className={'graphic'}>
				{isDefaultVariant ? variant.avatar : variant.illustration}
			</div>
			<div className={'titles'}>
				{isDefaultVariant ? (
					<div className={'text'}>{variant.text}</div>
				) : (
					<>
						<div className={'header'}>{variant.header}</div>
						{variant.body && <div className={'body'}>{variant.body}</div>}
					</>
				)}
			</div>
			{onClick && (
				<div className={'caret'}>
					<CaretRightIcon size={'XS'} />
				</div>
			)}
		</>
	);
	const fullClassName = cls('banner', className, variant.type);
	return onClick ? (
		<button
			className={fullClassName}
			onClick={onClick}
			style={maxLineStyle}
			data-testid={props['data-testid']}
		>
			{Inner}
		</button>
	) : (
		<div className={fullClassName}>{Inner}</div>
	);
};

Banner.displayName = 'Banner';

export default Banner;
